import React from 'react';

import { FaAngleDown } from 'react-icons/fa';
import { convertClassificationKeyToTitle } from '../../helpers/convertClassificationKeyToTitle';
import { Classification } from '../../types/ClassificationType';

interface SelectionDropdownProps {
    selectedItem: Classification;
    selectionItems: Classification[];
    additionalClasses?: string;
    onSelectItem: (item: Classification) => void;
    disabled?: boolean;
}
const SelectionDropdown: React.FC<SelectionDropdownProps> = (props) => {
    const { selectedItem, selectionItems, additionalClasses, onSelectItem, disabled } = props;

    const ref = React.useRef<HTMLDivElement>(null);
    const [isDropdownActive, setIsDropdownActive] = React.useState<boolean>(false);

    const onTriggerHandler = () => {
        setIsDropdownActive(!isDropdownActive);
    };

    const onBlurHandler = () => {
        setIsDropdownActive(false);
    };

    const onSelectHandler = (item: Classification) => {
        onSelectItem(item);
        setIsDropdownActive(!isDropdownActive);
    };

    React.useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (ref.current && !ref.current.contains(event.target as Node)) {
                setIsDropdownActive(false);
            }
        };

        document.addEventListener('click', handleClickOutside);

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [ref]);

    return (
        <div className={`dropdown ${isDropdownActive ? 'is-active' : ''} ${additionalClasses}`} ref={ref}>
            <div className={'dropdown-trigger'} onClick={onTriggerHandler}>
                <button
                    className="button is-light"
                    aria-haspopup="true"
                    aria-controls="dropdown-menu3"
                    disabled={disabled}
                >
                    <span>{convertClassificationKeyToTitle(selectedItem)}</span>
                    <span className="icon is-small">
                        <FaAngleDown />
                    </span>
                </button>
            </div>
            <div className="dropdown-menu" id="dropdown-menu3" role="menu">
                <div className="dropdown-content">
                    <div className="head">Afficher :</div>
                    {selectionItems.map((item: Classification) => (
                        <a
                            className="dropdown-item"
                            key={item}
                            onClick={() => {
                                onSelectHandler(item);
                            }}
                        >
                            {convertClassificationKeyToTitle(item)}
                        </a>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default SelectionDropdown;
